export default __webpack_public_path__ + "static/media/Dilmun.d3211cde.png";